import { fetchLookbookPages } from '@app/services/lookbookRepository';
import { isDefined } from '@app/utils/is';
import { skipToken, useQuery } from '@tanstack/react-query';
import { Lookbook } from '@typings';
import { AxiosError } from 'axios';

interface Props {
  lookbookId: Nullable<string>;
}

export const LOOKBOOK_PAGES_QUERY_KEY = 'lookbookPages';

export const useLookbookPages = ({ lookbookId }: Props) => {
  return useQuery<Lookbook.PageResponse[], AxiosError, Lookbook.Page[]>({
    enabled: isDefined(lookbookId),
    queryFn: isDefined(lookbookId) ? async () => fetchLookbookPages(lookbookId) : skipToken,
    queryKey: [LOOKBOOK_PAGES_QUERY_KEY, { lookbookId }],
    select: data => data.map(page => ({ ...page, id: page.id.toString() })),
  });
};
